<template>
  <component v-if="tipoCriterio && this.currentComponent"
             v-bind:is="currentComponent"
             v-bind="$attrs"
             @blur="onBlur"
             v-model="localValue"
             :metadata="metadata"/>
</template>

<script>
import './components';

export default {
  props: {
    value: [Array, Number, Object],
    tipoCriterio: {
      type: String,
    },
    metadata: {
      type: Object,
    },
    criteriosEnum: Array,
  },
  data() {
    return {
      currentComponent: null,
    };
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
  },
  methods: {
    buildComponent() {
      if (!this.tipoCriterio) {
        return;
      }
      const criterio = this.criteriosEnum.find(c => c.key === this.tipoCriterio);
      if (!criterio) {
        return;
      }
      this.currentComponent = `px-criterio-${criterio.componentSuffix}`;
    },
    onBlur(event) {
      this.$emit('blur', event);
    },
  },
  watch: {
    tipoCriterio(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.buildComponent();
    },
  },
  mounted() {
    this.buildComponent();
  },
};
</script>
